export default {
  TENANT_PAYMENTS_APPLICATIONS: 'companies/:company_id/tenant-payments-applications/',
  TENANT_PAYMENTS_EQUIPMENT: 'companies/:company_id/tenant-payments-equipment-purchase/',
}
